import React from 'react';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faMinus } from '@fortawesome/pro-light-svg-icons';
import {
  StyledSubnavWrapper,
  StyledSubnavContent,
  StyledIllustration,
  StyledIntro,
  StyledIntroTitle,
  StyledIntroDesc,
  StyledCtaButton,
  StyledGroupsWrapper,
  StyledGroup,
  StyledGroupTitle,
  StyledMenuItem,
  StyledMenuIcon,
  StyledMenuLink
} from './BaseSubnav.styled';

export interface SubnavItem {
  text: string;
  href: string;
  external?: boolean;
}

export interface SubnavGroup {
  title: string;
  items: SubnavItem[];
  cta?: {
    text: string;
    href: string;
  };
}

export interface BaseSubnavProps {
  illustration: string;
  title: string;
  description: string;
  cta?: {
    text: string;
    href: string;
  };
  groups: SubnavGroup[];
}

const BaseSubnav: React.FC<BaseSubnavProps> = ({
  illustration,
  title,
  description,
  cta,
  groups
}) => {
  return (
    <StyledSubnavWrapper>
      <StyledSubnavContent>
        <StyledIllustration>
          <img src={illustration} alt="" />
        </StyledIllustration>
        <StyledIntro>
          <StyledIntroTitle>{title}</StyledIntroTitle>
          <StyledIntroDesc>{description}</StyledIntroDesc>
          {cta && (
            <Link href={cta.href} passHref>
              <StyledCtaButton>
                {cta.text}
                <FontAwesomeIcon icon={faArrowRight} />
              </StyledCtaButton>
            </Link>
          )}
        </StyledIntro>
        <StyledGroupsWrapper>
          {groups.map((group, groupIndex) => (
            <StyledGroup key={groupIndex}>
              <StyledGroupTitle>{group.title}</StyledGroupTitle>
              {group.items.map((item, itemIndex) => (
                <StyledMenuItem key={itemIndex}>
                  <StyledMenuIcon>
                    <FontAwesomeIcon icon={faMinus} />
                  </StyledMenuIcon>
                  <Link href={item.href} passHref>
                    <StyledMenuLink
                      target={item.external ? '_blank' : undefined}
                      rel={item.external ? 'noopener noreferrer' : undefined}
                    >
                      {item.text}
                    </StyledMenuLink>
                  </Link>
                </StyledMenuItem>
              ))}
              {group.cta && (
                <Link href={group.cta.href} passHref>
                  <StyledCtaButton>
                    {group.cta.text}
                    <FontAwesomeIcon icon={faArrowRight} />
                  </StyledCtaButton>
                </Link>
              )}
            </StyledGroup>
          ))}
        </StyledGroupsWrapper>
      </StyledSubnavContent>
    </StyledSubnavWrapper>
  );
};

export default BaseSubnav;
